var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { staticClass: "ec-box" },
      [
        _c("loader", { attrs: { gif: _vm.gif } }),
        _vm._v(" "),
        _c("p", { staticClass: "ec-title" }, [
          _c("b", { domProps: { innerHTML: _vm._s(_vm.title) } })
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "ec-message",
          domProps: { innerHTML: _vm._s(_vm.message) }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "ec-message muted" }, [
          _vm._v("Isto poderá demorar um pouco")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75e66324", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e66324","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Preloader/Index.vue
// module id = null
// module chunks = 